import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const categoryNameMap: Record<string, string> = {
  celebrity: '明星黑料',
  influencer: '网红内幕',
  kol: '大V爆料',
  society: '社会热点',
  entertainment: '娱乐圈',
};

export default function ArticleList() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
      {articles.map((article) => (
        <Link
          key={article.id}
          to={`/article/${article.id}`}
          className="group cursor-pointer bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300/50 transition-all duration-300"
        >
          <div className="relative h-48 overflow-hidden">
            <img
              src={article.imageUrl}
              alt={article.title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute top-3 left-3 flex gap-2">
              {article.isHot && (
                <span className="bg-primary-500 text-background-50 text-xs font-bold px-2 py-0.5 rounded-full">
                  热门
                </span>
              )}
              {article.isTop && (
                <span className="bg-accent-500 text-background-50 text-xs font-bold px-2 py-0.5 rounded-full">
                  置顶
                </span>
              )}
            </div>
            <div className="absolute top-3 right-3">
              <span className="bg-background-950/60 backdrop-blur-sm text-background-50 text-xs px-2 py-0.5 rounded-full">
                {categoryNameMap[article.category] || article.category}
              </span>
            </div>
          </div>
          <div className="p-4">
            <h3 className="text-base font-semibold text-foreground-950 line-clamp-2 leading-snug mb-2 group-hover:text-primary-600 transition-colors duration-200">
              {article.title}
            </h3>
            <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-3">
              {article.excerpt}
            </p>
            <div className="flex items-center justify-between text-xs text-foreground-400">
              <span>{article.date}</span>
              <div className="flex items-center gap-1">
                <i className="ri-eye-line"></i>
                <span>{(article.views / 10000).toFixed(1)}万</span>
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}